import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { mapsbvh18eqox7a as map } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import {
  plus3pcnntex3h8m as plus,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  singleOrNullrknfaxokm1sl as singleOrNull,
  plus20p0vtfmu0596 as plus_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import {
  coroutineScope284yy3flyb2v2 as coroutineScope,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SortPart1gsioxz0aa07v as SortPart } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortPart.mjs';
import {
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  Reactive1jy75v4li6ldv as Reactive,
  Listenable3m4zqvjcbvczy as Listenable,
  beginUse146s8dwmfk72s as beginUse,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  asyncz02dsa2nb2zt as async,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  Key_instance2tirv2rj82ml4 as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = delay($this.xeo_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var closer = {_v: InterruptibleDelay$delay$lambda$slambda$lambda};
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ta5();
  var cont = cancellable;
  closer._v = $this.yeo_1.iem_1.vah(() => {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.rc(tmp$ret$0);
    return Unit_instance;
  });
  cont.va7((it) => {
    closer._v();
    return Unit_instance;
  });
  var tmp$ret$3 = cancellable.ua5();
  var tmp = returnIfSuspended(tmp$ret$3, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closer._v();
  return Unit_instance;
}
function InterruptibleDelay$delay$lambda$slambda$lambda() {
  return Unit_instance;
}
function *_generator_delay__nu7n9t($this, duration, $completion) {
  // Inline function 'kotlin.suspend' call
  var tmp$ret$0 = InterruptibleDelay$delay$slambda_0(duration);
  var tmp = listOf(tmp$ret$0);
  var tmp_0 = generateSequence($this, InterruptibleDelay$delay$lambda);
  var toRace = plus(tmp, map(tmp_0, InterruptibleDelay$delay$lambda_0));
  var tmp_1 = race(toRace, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var InterruptibleDelay$delay$slambdaClass;
function InterruptibleDelay$delay$slambda() {
  if (InterruptibleDelay$delay$slambdaClass === VOID) {
    class $ {
      constructor($duration) {
        this.xeo_1 = $duration;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    InterruptibleDelay$delay$slambdaClass = $;
  }
  return InterruptibleDelay$delay$slambdaClass;
}
function InterruptibleDelay$delay$slambda_0($duration) {
  var i = new (InterruptibleDelay$delay$slambda())($duration);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function InterruptibleDelay$delay$lambda(it) {
  return it.hem_1;
}
function InterruptibleDelay$delay$lambda_0(inter) {
  // Inline function 'kotlin.suspend' call
  return InterruptibleDelay$delay$lambda$slambda_0(inter);
}
var InterruptibleDelay$delay$lambda$slambdaClass;
function InterruptibleDelay$delay$lambda$slambda() {
  if (InterruptibleDelay$delay$lambda$slambdaClass === VOID) {
    class $ {
      constructor($inter) {
        this.yeo_1 = $inter;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    InterruptibleDelay$delay$lambda$slambdaClass = $;
  }
  return InterruptibleDelay$delay$lambda$slambdaClass;
}
function InterruptibleDelay$delay$lambda$slambda_0($inter) {
  var i = new (InterruptibleDelay$delay$lambda$slambda())($inter);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var InterruptibleDelayClass;
function InterruptibleDelay() {
  if (InterruptibleDelayClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.hem_1 = parent;
        this.iem_1 = BasicListenable().paq();
      }
      qen() {
        this.iem_1.qaq();
      }
      vat() {
        return new (InterruptibleDelay())(this);
      }
      jem(duration, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delay__nu7n9t.bind(VOID, this, duration), $completion);
      }
    }
    initMetadataForClass($, 'InterruptibleDelay', InterruptibleDelay, VOID, VOID, [1]);
    InterruptibleDelayClass = $;
  }
  return InterruptibleDelayClass;
}
function ResourceUse(parentScope, action) {
  parentScope = parentScope === VOID ? get_AppScope() : parentScope;
  return new (ResourceUse$1())(parentScope, action);
}
function uses(_this__u8e3s4, resource) {
  return new (uses$1())(_this__u8e3s4, resource);
}
function race(racers, $completion) {
  return coroutineScope(race$slambda_0(racers), $completion);
}
var BaseResourceUseClass;
function BaseResourceUse() {
  if (BaseResourceUseClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        this.veo_1 = 0;
      }
      kal() {
      }
      lal() {
      }
      kaj() {
        var _unary__edvuaz = this.veo_1;
        this.veo_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.kal();
        }
        var dead = {_v: false};
        return () => {
          var tmp;
          if (dead._v) {
            return Unit_instance;
          }
          dead._v = true;
          var tmp_0;
          this.veo_1 = this.veo_1 - 1 | 0;
          if (this.veo_1 === 0) {
            this.lal();
            tmp_0 = Unit_instance;
          }
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($, 'BaseResourceUse');
    BaseResourceUseClass = $;
  }
  return BaseResourceUseClass;
}
function *_generator_waitFor__s3rt0g(_this__u8e3s4, matching, $completion) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var this_0 = _this__u8e3s4.sah();
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
        if (matching((tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE()))
          return Unit_instance;
        tmp = Unit_instance;
      } else {
        if (matching(_ReactiveState___get_raw__impl__92ipya(this_0)))
          return Unit_instance;
        tmp = Unit_instance;
      }
    }
  }
  var close = {_v: null};
  try {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ta5();
    var cont = cancellable;
    close._v = _this__u8e3s4.vah(() => {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      var this_0 = _this__u8e3s4.sah();
      var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
      var tmp;
      if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
          tmp = null;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
            var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            if (matching(it)) {
              // Inline function 'kotlin.coroutines.resume' call
              var this_1 = cont;
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
              this_1.rc(tmp$ret$10);
            }
            tmp = Unit_instance;
          } else {
            var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
            if (matching(it_0)) {
              // Inline function 'kotlin.coroutines.resume' call
              var this_2 = cont;
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$14 = _Result___init__impl__xyqfz8(Unit_instance);
              this_2.rc(tmp$ret$14);
            }
            tmp = Unit_instance;
          }
        }
      }
      return Unit_instance;
    });
    var tmp$ret$21 = cancellable.ua5();
    var tmp_1 = returnIfSuspended(tmp$ret$21, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }finally {
    var tmp0_safe_receiver = close._v;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  return Unit_instance;
}
function waitFor(_this__u8e3s4, matching, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_waitFor__s3rt0g.bind(VOID, _this__u8e3s4, matching), $completion);
}
function debounce(_this__u8e3s4, scope, duration) {
  return new (DebounceReactive())(_this__u8e3s4, scope, duration);
}
function ensureTotal(_this__u8e3s4, serializer) {
  var tmp0_safe_receiver = lastOrNull(_this__u8e3s4);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n4a_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l4q();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : singleOrNull(tmp2_safe_receiver);
  if ((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.i20()) === '_id')
    return _this__u8e3s4;
  var tmp = new (DataClassPathSelf())(serializer);
  // Inline function 'kotlin.collections.find' call
  var tmp0 = ensureNotNull(get_serializableProperties(serializer));
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.i20() === '_id') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp_0 = tmp$ret$1;
  return plus_0(_this__u8e3s4, new (SortPart())(new (DataClassPathAccess())(tmp, (!(tmp_0 == null) ? isInterface(tmp_0, SerializableProperty()) : false) ? tmp_0 : THROW_CCE())));
}
var DebounceReactiveClass;
function DebounceReactive() {
  if (DebounceReactiveClass === VOID) {
    class $ {
      constructor(source, scope, duration) {
        this.zeo_1 = new (DebounceListenable())(source, scope, duration);
        this.aep_1 = source;
        this.bep_1 = scope;
        this.cep_1 = duration;
      }
      sah() {
        return this.aep_1.sah();
      }
      toString() {
        return 'DebounceReactive(source=' + toString(this.aep_1) + ', scope=' + toString(this.bep_1) + ', duration=' + Duration__toString_impl_8d916b(this.cep_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.aep_1);
        result = imul(result, 31) + hashCode(this.bep_1) | 0;
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.cep_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DebounceReactive()))
          return false;
        if (!equals(this.aep_1, other.aep_1))
          return false;
        if (!equals(this.bep_1, other.bep_1))
          return false;
        if (!(this.cep_1 === other.cep_1))
          return false;
        return true;
      }
      vah(listener) {
        return this.zeo_1.vah(listener);
      }
      kaj() {
        return this.zeo_1.kaj();
      }
    }
    initMetadataForClass($, 'DebounceReactive', VOID, VOID, [Reactive(), Listenable()]);
    DebounceReactiveClass = $;
  }
  return DebounceReactiveClass;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = delay($this.hep_1.fep_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if ($this.iep_1 === $this.hep_1.gep_1)
    $this.jep_1();
  return Unit_instance;
}
var DebounceListenable$addListener$lambda$slambdaClass;
function DebounceListenable$addListener$lambda$slambda() {
  if (DebounceListenable$addListener$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $num, $listener) {
        this.hep_1 = this$0;
        this.iep_1 = $num;
        this.jep_1 = $listener;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DebounceListenable$addListener$lambda$slambdaClass = $;
  }
  return DebounceListenable$addListener$lambda$slambdaClass;
}
function DebounceListenable$addListener$lambda$slambda_0(this$0, $num, $listener) {
  var i = new (DebounceListenable$addListener$lambda$slambda())(this$0, $num, $listener);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var DebounceListenableClass;
function DebounceListenable() {
  if (DebounceListenableClass === VOID) {
    class $ {
      constructor(source, scope, duration) {
        this.dep_1 = source;
        this.eep_1 = scope;
        this.fep_1 = duration;
        this.gep_1 = 0;
      }
      vah(listener) {
        return this.dep_1.vah(() => {
          this.gep_1 = this.gep_1 + 1 | 0;
          var num = this.gep_1;
          launch(this.eep_1, VOID, VOID, DebounceListenable$addListener$lambda$slambda_0(this, num, listener));
          return Unit_instance;
        });
      }
      toString() {
        return 'DebounceListenable(source=' + toString(this.dep_1) + ', scope=' + toString(this.eep_1) + ', duration=' + Duration__toString_impl_8d916b(this.fep_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.dep_1);
        result = imul(result, 31) + hashCode(this.eep_1) | 0;
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.fep_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DebounceListenable()))
          return false;
        if (!equals(this.dep_1, other.dep_1))
          return false;
        if (!equals(this.eep_1, other.eep_1))
          return false;
        if (!(this.fep_1 === other.fep_1))
          return false;
        return true;
      }
    }
    protoOf($).kaj = beginUse;
    initMetadataForClass($, 'DebounceListenable', VOID, VOID, [Listenable()]);
    DebounceListenableClass = $;
  }
  return DebounceListenableClass;
}
var ResourceUse$1Class;
function ResourceUse$1() {
  if (ResourceUse$1Class === VOID) {
    class $ {
      constructor($parentScope, $action) {
        this.kep_1 = $parentScope;
        this.lep_1 = $action;
      }
      kaj() {
        var job = Job(this.kep_1.ga2().cd(Key_instance));
        launch(CoroutineScope_0(this.kep_1.ga2().gp(job)), VOID, VOID, this.lep_1);
        return () => {
          job.oa3();
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($);
    ResourceUse$1Class = $;
  }
  return ResourceUse$1Class;
}
var uses$1Class;
function uses$1() {
  if (uses$1Class === VOID) {
    class $ {
      constructor($this_uses, $resource) {
        this.oep_1 = $this_uses;
        this.pep_1 = $resource;
        this.mep_1 = 0;
        this.nep_1 = null;
      }
      sah() {
        return this.oep_1.sah();
      }
      vah(listener) {
        var _unary__edvuaz = this.mep_1;
        this.mep_1 = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz === 0) {
          this.nep_1 = this.pep_1.kaj();
        }
        var original = this.oep_1.vah(listener);
        return () => {
          original();
          var tmp;
          this.mep_1 = this.mep_1 - 1 | 0;
          if (this.mep_1 === 0) {
            var tmp0_safe_receiver = this.nep_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver();
            this.nep_1 = null;
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
      }
    }
    protoOf($).kaj = beginUse;
    initMetadataForClass($, VOID, VOID, VOID, [Reactive()]);
    uses$1Class = $;
  }
  return uses$1Class;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp = $this.qep_1.ga4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var winningCandidate = tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.rep_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!equals($this.qep_1, element)) {
      element.oa3();
    }
  }
  $this.sep_1.pa8(winningCandidate);
  return Unit_instance;
}
var race$slambda$slambdaClass;
function race$slambda$slambda() {
  if (race$slambda$slambdaClass === VOID) {
    class $ {
      constructor($racer) {
        this.tep_1 = $racer;
      }
      yah($this$async, $completion) {
        return this.tep_1($completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    race$slambda$slambdaClass = $;
  }
  return race$slambda$slambdaClass;
}
function race$slambda$slambda_0($racer) {
  var i = new (race$slambda$slambda())($racer);
  var l = ($this$async, $completion) => i.yah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var race$slambda$slambdaClass_0;
function race$slambda$slambda_1() {
  if (race$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($racer, $list, $winningValue) {
        this.qep_1 = $racer;
        this.rep_1 = $list;
        this.sep_1 = $winningValue;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    race$slambda$slambdaClass_0 = $;
  }
  return race$slambda$slambdaClass_0;
}
function race$slambda$slambda_2($racer, $list, $winningValue) {
  var i = new (race$slambda$slambda_1())($racer, $list, $winningValue);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var race$slambdaClass;
function race$slambda() {
  if (race$slambdaClass === VOID) {
    class $ {
      constructor($racers) {
        this.uep_1 = $racers;
      }
      yah($this$coroutineScope, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.uep_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, race$slambda$slambda_0(item));
          destination.v(tmp$ret$0);
        }
        var list = destination;
        var winningValue = CompletableDeferred();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = list.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element = _iterator__ex2g4s_0.o1();
          launch($this$coroutineScope, VOID, VOID, race$slambda$slambda_2(element, list, winningValue));
        }
        return winningValue.ga4($completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    race$slambdaClass = $;
  }
  return race$slambdaClass;
}
function race$slambda_0($racers) {
  var i = new (race$slambda())($racers);
  var l = ($this$coroutineScope, $completion) => i.yah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  BaseResourceUse as BaseResourceUse29ny90pfhtji3,
  InterruptibleDelay as InterruptibleDelay2c0xh0wdvl7bj,
  ResourceUse as ResourceUse2vo6us5ch1uy1,
  debounce as debounce38x13ynq48dvf,
  ensureTotal as ensureTotaldlyk8c4gc8xl,
  uses as uses26aso754i5iou,
  waitFor as waitFor2a46u14jq5a6t,
};
//endregion

//# sourceMappingURL=utils.mjs.map
